/* eslint-disable no-use-before-define */
import { getConfig, format } from './all'

export let getServerTime = (d = new Date()) => {
    d = d || new Date()
    let off = getConfig('timezoneOffset', 0)
    d.setHours(d.getHours() + off)
    return d
}

let getYieldGridEndOfDayTime = (id='endOfDayTime') => {
    let eod = Math.min(getConfig(id, 1700), 1700)
    return eod===1700 ? 1655 : eod
}

let getYieldGridOffHours = () => {
    let d = getServerTime()

    if (isHoliday(d)) return 'holiday'

    let hm = d.getHours() * 100 + d.getMinutes()
    let sod = 800
    let eod = getYieldGridEndOfDayTime()

    return hm<sod ? 'before' :
        hm>eod ? 'after' :
        null
}

export let toMdy = (dt) => {
    return dt
        .toLocaleDateString("en-US")
        .replace(/\u200E/g, '')
}

export let isHoliday = (dt) => {
    return dt.getDay() === 6 // sat
        || dt.getDay() === 0 // sun
        || getConfig('next_holiday', [])
            .indexOf(toMdy(dt)) >= 0
}


export let yieldGridLastUpdated = () => {
    let hr = getYieldGridOffHours()
    if (!hr) return ''

    let isPrevious = (hr==='holiday' || hr==='before')
    let d = isPrevious
        ? new Date(getConfig('previous_business_day'))
        : new Date(getServerTime().setHours(0,0,0,0))

    let eod = getYieldGridEndOfDayTime(
        isPrevious
        ? 'previousEndOfDayTime'
        : 'endOfDayTime'
    )

    return `Last Updated: ${ format.date(d) } ${ hhmmToString(eod)} ET`
}

let hhmmToString = (hhmm) => {
    var hh = Math.floor(hhmm / 100)
    let mm = Math.floor(hhmm % 100)
    var pm = 'AM'
    if (hh>12) {
        hh -= 12
        pm = 'PM'
    }
    return `${hh}:${mm<10 ? '0':''}${mm} ${pm}`
}